import { Heading } from 'components/Heading'
import { P } from 'components/Typography/P'
import { YouTubeEmbed, YouTubeVid } from 'components/YouTube'
import React from 'react'
import styled, { css } from 'styled-components'

export const videoStyles = css`
	.details {
		padding: 20px ${props => props.theme.sizes.gutter.mobile.val};
		p {
			color: ${props => props.theme.colors.secondary.val};
			font-size: 1.2rem;
		}
	}
`

const VideoView = styled.div`
	${videoStyles}
`

type VideoProps = {
	yTVideo?: YouTubeVid
}
export const Video = ({ yTVideo }: VideoProps) => {
	const { length, title, datePosted, tags, description } = yTVideo || {}
	return (
		<VideoView>
			{yTVideo ? <YouTubeEmbed video={yTVideo} /> : null}
			<div className='details'>
				{title ? <Heading displayType='block-heading'>{title}</Heading> : null}
				{description ? <P>{description}</P> : null}
				{tags?.length ? (
					<P>
						{tags.map((tag, idx) => (
							<span key={idx}>{tag}, </span>
						))}
					</P>
				) : null}
				{datePosted ? (
					<P>
						{datePosted} - {length}
					</P>
				) : null}
			</div>
		</VideoView>
	)
}
